export default "__VITE_ASSET__CUAyTGkh__"